import * as React from "react";
const breakpoints = {
    sm: "(min-width: 40rem)",
    md: "(min-width: 48rem)",
    lg: "(min-width: 64rem)",
    xl: "(min-width: 80rem)",
    "2xl": "(min-width: 96rem)",
};
export default function useTailwindBreakpoint(key) {
    const query = breakpoints[key];
    const [matches, setMatches] = React.useState(false);
    React.useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches)
            setMatches(media.matches);
        const listener = () => setMatches(media.matches);
        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }, [query, matches]);
    return matches;
}
